import React, {useState, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "@ts-digital/vrc";
import {  useSelector } from "react-redux";
import { Pagination } from "antd";
import Table from "../vapor/table";
import moment from "moment";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DATE_FORMAT_FOR_DISPLAY } from "../../constants/constants";

const DeadlinesRecurrency = props => {
  const {
    modalVisible,
    closeModalFunc    
  } = props;
  const navigate = useNavigate();
  const deadlines = useSelector(state => state.deadlinesDetail.recurrency.listDeadlines);
  const [current, setCurrent] = useState(1);
  const [deadlinesPage, setDeadlinesPage] = useState(deadlines);
  let deadlinesToShow = [];

  const goToDeadline = (deadlineId) => {
    navigate("/scadenza/" + deadlineId);
    closeModalFunc(false);
  };

  useEffect(()=> {
    setCurrent(1);
    let deadlines_copy = deadlines.slice();
    setDeadlinesPage(deadlines_copy.slice(0,6));
  }, [modalVisible]);

  const setCurrentPage = (page) => {
    setCurrent(page);
    let deadlines_copy = deadlines.slice();
    let start =  (page - 1) * 6;
    let end = start + 6;
    setDeadlinesPage(deadlines_copy.slice(start,end));
  };

  deadlinesPage.map((itm) => {

    deadlinesToShow.push({index: deadlines.indexOf(itm) + 1,
      date: moment(itm.date).format(DATE_FORMAT_FOR_DISPLAY),
      amount: itm.totalAmount > 0 ? (
        <div style={{ display: "flex", alignItems: "center" }}>
          <FontAwesomeIcon
            icon={["fas", "plus-circle"]}
            style={{ fontSize: 12, color: "#0d6d80", marginRight: 8 }}
          />
          {itm.totalAmount ? new Intl.NumberFormat("it-IT", {
            style: "decimal",
            currency: "EUR",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(Math.abs(parseFloat(itm.totalAmount))) + " €" : "0 €"}
        </div>
      ) : (
        <div style={{ display: "flex", alignItems: "center" }}>
          <FontAwesomeIcon
            icon={["fas", "minus-circle"]}
            style={{ fontSize: 12, color: "#c53090", marginRight: 8 }}
          />
          {itm.totalAmount ? new Intl.NumberFormat("it-IT", {
            style: "decimal",
            currency: "EUR",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(Math.abs(parseFloat(itm.totalAmount))) + " €" : "0 €"}
        </div>
      ),
      arrow: <div onClick={e => goToDeadline(itm.id)} style={{
        color: "#0090d1",
        cursor: "pointer"
      }}><FontAwesomeIcon
          icon={["far", "arrow-right"]}
          style={{ marginRight: 8 }}
        /></div>});
    return null;
  });

  const columns = [
    {
      title: "Scadenza",
      dataKey: "index",
      style: { minWidth: 100}
    },
    {
      title: "Data scadenza",
      dataKey: "date",
      style: { minWidth:170 }
    },
    {
      title: "Importo",
      dataKey: "amount",
      style: { minWidth: 120, paddingLeft: 18 }
    },
    {
      title: "",
      dataKey: "arrow",
      style: { minWidth: 20 }
    }
  ];

  return (
    modalVisible && (
      <Modal
        visible={modalVisible}
        title={<FormattedMessage id="deadlines.title" />}
        onClose={e => {closeModalFunc();}}
        type="primary"
        outsideClosable={false}
        footer={
          <div style={{ padding: "8px 0", width: "100%", textAlign: "right" }}>
            <Button
              kind="secondary"
              colorScheme={"ghost"}
              style={{ marginRight: "16px" }}
              className="buttonNav"
              onClick={closeModalFunc}
            >
              <FormattedMessage id="actions.close" />
            </Button>

          </div>
        }
      >
        <div style = {{width:"420px"}}>
          <div>
            <Table
              columns={columns}
              dataSource={deadlinesToShow}
              selection={false}
              bodyHeight={245}
            />
          </div>
          <div style={{float: "right", marginBottom: "20px"}}>
            <Pagination defaultCurrent={current} current={current} showSizeChanger={false} size="small" total={parseInt(deadlines.length/6 * 10)} onChange={setCurrentPage}/>
          </div>
        </div>
      </Modal>
    )
  );
};
// <Pagination showSizeChanger={false} size="small" total={1000} />
export default DeadlinesRecurrency;
